export const ultimasNoticias = [
    {
         "imagen" : "images/comunicados/Transparencia2026.png",
         "url" : "images/comunicados/Convocatoria Transparencia en Corto 2026.pdf",
         "titulo" : "Transparencia en Corto",
         "fecha" : "año 2026"
    }, 
    {
         "imagen" : "images/comunicados/protocolocero.jpg",
         "url" : "/ProcoloCero/ProtocoloCero",
         "titulo" : "Protocolo Cero",
         "fecha" : "año 2023"
     },
    {
        "imagen" : "images/comunicados/aclimafel.jpg",
        "url" : "images/comunicados/Alerta_Veraliprida.pdf",
        "titulo" : "LA COFEPRIS INFORMA SOBRE LA SUSPENSIÓN DE COMERCIALIZACIÓN Y USO DEL PRODUCTO ACLIMAFEL",
        "fecha" : "año 2023"
    },
    
    
    
]
